import * as React from 'react';

import type {OutcomeType} from 'nutshell-graphql-types';
import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {CLOSED_LEAD_DRIP_SEQUENCE_START_TRIGGERS} from '../../constants';

import {ClosedLeadDripSequenceStartTriggerCard} from '../cards/closed-lead-drip-sequence-start-trigger-card';

import {CardsContainer} from './cards-container';

type Props = {
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
    outcomeType: OutcomeType;
};

const defaultAutomations = {nutshellMarketingStartTriggers: []} as const;

export function ClosedLeadDripSequenceStartTriggersContainer(props: Props) {
    const automations =
        props.closedLeadAutomations.find(
            (automation) => automation.outcomeType === props.outcomeType
        ) || defaultAutomations;

    const cards = automations.nutshellMarketingStartTriggers.map((subscription) => {
        return (
            <ClosedLeadDripSequenceStartTriggerCard
                key={subscription.id}
                parentId={props.outcomeType}
                startTrigger={subscription}
            />
        );
    });

    return (
        <CardsContainer
            type={CLOSED_LEAD_DRIP_SEQUENCE_START_TRIGGERS}
            isCardBeingDragged={false} // Can't drag on closed lead board for right now
            isLoading={props.isLoading}
            errorMessage={props.errorMessage}
            hideAddCard={false}
            parentId={props.outcomeType}
        >
            {cards}
        </CardsContainer>
    );
}
